import { usePageVersions } from '@features/page-versions';
import { orgMetadataHook } from '@hooks/metadata';
import { BrowserUtility } from '@utility/browser-utility';
import { CommonUtility } from '@utility/common';
import { CommonConstant } from '@utility/constants/common';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from './auth';

// @ts-expect-error - TS2554: Expected 1 arguments, but got 0.
const OrgMetadataContext = createContext();

export function OrgMetadataProvider({ children }) {
  const { user, isAuthenticated, wmsPortal } = useAuth();
  /* Legacy marketplaces and regions (Mongo): a V2 account never asks; its connections are in Settings → Connections. */
  const versions = usePageVersions();
  const legacyMetadata = versions.known && !versions.isV2('orders');
  const { marketplaces, regions, loading, refreshMetadata, defaultRegionId } =
    orgMetadataHook(isAuthenticated && legacyMetadata, wmsPortal);
  const [isSummaryView, setSummaryView] = useState(
    !!BrowserUtility.getSummaryView(),
  );

  const updateSummaryView = flag => {
    BrowserUtility.storeSummaryView(flag);
    setSummaryView(flag);
  };

  useEffect(() => {
    if (BrowserUtility.isSummaryViewExists()) {
      const summaryView = BrowserUtility.getSummaryView();

      const isUserAdmin = CommonUtility.isSummaryAdmin(user);
      if (summaryView) {
        if (isUserAdmin) {
          BrowserUtility.storeSummaryView(true);
          setSummaryView(true);
        } else {
          BrowserUtility.remove(CommonConstant.lsSummaryView);
        }
      }
    }
  }, [user]);

  return (
    <OrgMetadataContext.Provider
      value={{
        marketplaces,
        regions,
        loading,
        refreshMetadata,
        defaultRegionId,
        isSummaryView,
        setSummaryView: updateSummaryView,
      }}
    >
      {children}
    </OrgMetadataContext.Provider>
  );
}

export const useMetadata = () => useContext(OrgMetadataContext);
